export type UsageQuota = {
	usedBytes: number,
	grantedBytes: number,
};

export const queryUsageAndQuota = (): Promise<UsageQuota> =>
	new Promise((resolve, reject) =>
		// $FlowFixMe: how can we extend a built-in declaration?
		navigator.webkitPersistentStorage.queryUsageAndQuota(
			(usedBytes, grantedBytes) => resolve({usedBytes, grantedBytes}),
			error => reject(error),
		),
	);

export const requestQuota = (size: number): Promise<number> =>
	new Promise((resolve, reject) =>
		// $FlowFixMe: how can we extend a built-in declaration?
		navigator.webkitPersistentStorage.requestQuota(
			size,
			grantedBytes => resolve(grantedBytes),
			error => reject(error),
		),
	);

export const getPersistentFileSystem = (size: number): Promise<FileSystem> =>
	new Promise((resolve, reject) =>
		window.webkitRequestFileSystem(
			window.PERSISTENT,
			size,
			(fileSystem: FileSystem) => resolve(fileSystem),
			(error: FileError) => reject(error),
		),
	);

export const getDirectoryEntry = (
	fileSystem: FileSystem,
	name: string,
): Promise<FileSystemDirectoryEntry> =>
	new Promise((resolve, reject) =>
		fileSystem.root.getDirectory(
			name,
			{create: true},
			(dirEntry: FileSystemDirectoryEntry) => resolve(dirEntry),
			(error: FileError) => reject(error),
		),
	);

export const getFileEntry = (
	dirEntry: FileSystemDirectoryEntry,
	name: string,
): Promise<FileSystemFileEntry> =>
	new Promise((resolve, reject) =>
		dirEntry.getFile(
			name,
			{},
			(fileEntry: FileSystemFileEntry) => resolve(fileEntry),
			(error: FileError) => reject(error),
		),
	);

export const deleteFileEntry = (
	dirEntry: FileSystemDirectoryEntry,
	name: string,
): Promise<void> =>
	new Promise((resolve, reject) =>
		getFileEntry(dirEntry, name).then(fileEntry =>
			fileEntry.remove(
				() => resolve(),
				(error: FileError) => reject(error),
			),
		),
	);

export const createFileEntry = (
	dirEntry: FileSystemDirectoryEntry,
	name: string,
): Promise<FileSystemFileEntry> =>
	new Promise((resolve, reject) =>
		dirEntry.getFile(
			name,
			{create: true, exclusive: true},
			(fileEntry: FileSystemFileEntry) => resolve(fileEntry),
			(error: FileError) => reject(error),
		),
	);

export const getFileWriter = (
	fileEntry: FileSystemFileEntry,
): Promise<FileWriter> =>
	new Promise((resolve, reject) =>
		fileEntry.createWriter(
			(fileWriter: FileWriter) => resolve(fileWriter),
			(error: FileError) => reject(error),
		),
	);



// WEBPACK FOOTER //
// ./src/lib/fs/index.js